// import logo from './logo.svg';
import './App.css';
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import ErrorBoundary from "./errorBoundary/ErrorBoundary";
import Wrapper from "./wrapper/Wrapper";
import PrivacyPolicy from './privacy/PrivacyPolicy';
import AnimeFanPage from './AnimePage/AnimeFanPage';
import AppAds from './App-Ads/appAds';
import MusicPlayer from './musicPlayer/MusicPlayer';
import MultimediaPlayerPrivacyPolicy from './MultimediaPlayer/MultimediaPlayerPrivacyPolicy';

function App() {

  const routes = [
    {
      path:"/",
      element:<Wrapper/>
    }
    ,
    {
      path:"/privacy",
      element:<PrivacyPolicy/>
    }
    ,
    {
      path:"/anime",
      element:<AnimeFanPage/>
    }
    ,
    {
      path:"/app-ads.txt",
      element: <AppAds/>
    }
    ,
    {
      path:"/musicPlayerPrivacyPolicy",
      element: <MusicPlayer/>
    }
    ,
    {
      path:"/multimediaPlayerPrivacyPolicy",
      element: <MultimediaPlayerPrivacyPolicy/>
    }
  ]

  const router = createBrowserRouter(routes);

  return (
    <div className="">
      <ErrorBoundary>
        <RouterProvider router={router} >
        
        </RouterProvider>
      </ErrorBoundary>
    </div>
  );
}

export default App;
